import { render, staticRenderFns } from "./RegisterRecipientDialog.vue?vue&type=template&id=7aeee92e&scoped=true&"
import script from "./RegisterRecipientDialog.js?vue&type=script&lang=js&"
export * from "./RegisterRecipientDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeee92e",
  null
  
)

export default component.exports